import api from './Api'
import { EProgram } from './program';

export enum EProgramBooking {
    id = 'id',
    programId = 'programId',
    programTitle = 'programTitle',
    programEventId = 'programEventId',
    memberName = 'memberName',
    memberMobile = 'memberMobile',
    targetDateTime = 'targetDateTime',
    bookingDateTime = 'bookingDateTime',
    paidAmount = 'paidAmount',
    status = 'status',
    note = 'note',
    tossPayId = 'tossPayId',
    paidDateTime = 'paidDateTime',
    requestCancelDateTime = 'requestCancelDateTime',
    programBookingSelectOptionList = 'programBookingSelectOptionList',
    programBookingSubjectOptionList = 'programBookingSubjectOptionList',
    programBookingTicketList = 'programBookingTicketList',
}
export enum EProgramBookingSelectOption {
    id = 'id',
    programSelectOptionId = 'programSelectOptionId',
    programSelectOptionItemIdList = 'programSelectOptionItemIdList',
}
export enum EProgramBookingSubjectOption {
    id = 'id',
    programSubjectOptionId = 'programSubjectOptionId',
    content = 'content',
}

export enum EProgramBookingTicket {
    id = 'id',
    programTicketId = 'programTicketId',
    programBookingId = 'programBookingId',
    count = 'count',
    name = 'name'
}

const defaultFieldListMap: IProgramBookingField = {
    programBooking: [EProgramBooking.id, EProgramBooking.memberName, EProgramBooking.memberMobile, EProgramBooking.targetDateTime, EProgramBooking.bookingDateTime, EProgramBooking.paidAmount, EProgramBooking.status, EProgramBooking.programBookingSelectOptionList, EProgramBooking.programBookingSubjectOptionList, EProgramBooking.programBookingTicketList, EProgramBooking.tossPayId],
    [EProgramBooking.programBookingSelectOptionList]: [EProgramBookingSelectOption.id, EProgramBookingSelectOption.programSelectOptionId, EProgramBookingSelectOption.programSelectOptionItemIdList],
    [EProgramBooking.programBookingSubjectOptionList]: [EProgramBookingSubjectOption.id, EProgramBookingSubjectOption.programSubjectOptionId, EProgramBookingSubjectOption.content],
    [EProgramBooking.programBookingTicketList]: [EProgramBookingTicket.id, EProgramBookingTicket.programTicketId, EProgramBookingTicket.programBookingId, EProgramBookingTicket.count]
}

const transformData = (inputFields: IProgramBookingField) => {
    const fieldListMap: Record<string, string[]> = {};
    let queryFieldListMap: string = '';
    const keys = Object.keys(inputFields)

    Object.entries(inputFields).forEach(([key, values]) => {
        const filteredValues = values.filter((value: string) => !keys.includes(value));
        if (filteredValues.length > 0) {
            fieldListMap[key] = filteredValues;
        }
        queryFieldListMap.includes(key)
            ? queryFieldListMap = queryFieldListMap.replace(key, `${key} { ${values.join(' ')} }`)
            : queryFieldListMap += values.join(' ')
    });
    return { queryFieldListMap, fieldListMap };
};

export const getAllProgramBookingAdminByProgramId = <T>(programId: number, programBookingField: IProgramBookingField = defaultFieldListMap) => {
    const { queryFieldListMap, fieldListMap } = transformData(programBookingField)
    const query = `query GetAllProgramBookingAdminByProgramId($programId: ID!, $fieldListMap: JSON) { getAllProgramBookingAdminByProgramId(programId:$programId, fieldListMap:$fieldListMap) { ${queryFieldListMap} } }`
    return api.post<IGraphqlResponse<{ getAllProgramBookingAdminByProgramId: T }>>(`/graphql`, { query, variables: { programId, fieldListMap } })
};

export const updateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest = (updateProgramBookingStatusRequest: IUpdateProgramBookingStatusAdminRequest) => {
    const query = `mutation UpdateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest($updateProgramBookingStatusRequest: UpdateProgramBookingStatusRequest) { updateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest(updateProgramBookingStatusRequest:$updateProgramBookingStatusRequest) }`
    return api.post<IGraphqlResponse<{ updateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest: boolean }>>(`/graphql`, { query, variables: { updateProgramBookingStatusRequest } })
}

export const updateProgramBookingAdminByUpdateProgramBookingAdminRequest = (updateProgramBookingAdminRequest: IUpdateProgramBookingAdminRequest) => {
    const query = `mutation UpdateProgramBookingAdminByUpdateProgramBookingAdminRequest($updateProgramBookingAdminRequest: UpdateProgramBookingAdminRequest) { updateProgramBookingAdminByUpdateProgramBookingAdminRequest(updateProgramBookingAdminRequest:$updateProgramBookingAdminRequest) }`
    return api.post<IGraphqlResponse<{ updateProgramBookingAdminByUpdateProgramBookingAdminRequest: boolean }>>(`/graphql`, { query, variables: { updateProgramBookingAdminRequest } })
}

export const getProgramBookingAdminByProgramBookingId = <T>(programBookingId: number, programBookingField: IProgramBookingField = defaultFieldListMap) => {
    const { queryFieldListMap, fieldListMap } = transformData(programBookingField)
    const query = `query GetProgramBookingAdminByProgramBookingId($programBookingId: ID!, $fieldListMap: JSON) { getProgramBookingAdminByProgramBookingId(programBookingId:$programBookingId, fieldListMap:$fieldListMap) { ${queryFieldListMap} } }`
    return api.post<IGraphqlResponse<{ getProgramBookingAdminByProgramBookingId: T }>>(`/graphql`, { query, variables: { programBookingId, fieldListMap } })
};

export const getProgramBookingCheckInAdminByMemberMobileAndStatusAndTargetDateTimeIsNotBeforeNow = (memberMobile: string, status: string) => {
    return api.get<IProgramCheckInAdminResponse>(`/program-booking-check-in/admin/mobile/${memberMobile}/${status}`)
}

export const getProgramBookingCheckInAdminByProgramBookingIdAndStatusAndTargetDateTimeIsNotBeforeNow = (programBookingId: number) => {
    return api.get<IProgramCheckInAdminResponse>(`/program-booking-check-in/admin/program-booking-id/${programBookingId}`)
}

const customFieldListMap = {
    programBooking: [EProgramBooking.id, 'programId', 'programTitle', EProgramBooking.status, EProgramBooking.paidAmount, EProgramBooking.bookingDateTime, EProgramBooking.targetDateTime, EProgramBooking.programBookingTicketList],
    programBookingTicketList: [EProgramBookingTicket.name, EProgramBookingTicket.count],
}

export const getAllProgramBookingForMemberByMemberId = <T>(memberId: number, programField = customFieldListMap) => {
    const { queryFieldListMap, fieldListMap } = transformData(programField)
    const query = `query GetAllProgramBookingForMemberByMemberId($memberId:ID!, $fieldListMap: JSON) { getAllProgramBookingForMemberByMemberId(memberId:$memberId, fieldListMap:$fieldListMap) { ${queryFieldListMap} } }`
    return api.post<IGraphqlResponse<{ getAllProgramBookingForMemberByMemberId: T }>>(`/graphql`, { query, variables: { memberId, fieldListMap } })
}
const customProgramBookingFieldListMap = {
    programBooking: [EProgramBooking.id, EProgramBooking.programTitle, EProgramBooking.memberName, EProgramBooking.memberMobile, EProgramBooking.targetDateTime, EProgramBooking.requestCancelDateTime, EProgramBooking.status],
}

export const getAllProgramBookingForCancelManage = <T>(statusList: string[], programBookingField = customProgramBookingFieldListMap) => {
    const { queryFieldListMap, fieldListMap } = transformData(programBookingField)
    const query = `query GetAllProgramBookingForCancelManage($statusList:[String], $fieldListMap: JSON) { getAllProgramBookingForCancelManage(statusList:$statusList, fieldListMap:$fieldListMap) { ${queryFieldListMap} } }`
    return api.post<IGraphqlResponse<{ getAllProgramBookingForCancelManage: T }>>(`/graphql`, { query, variables: { statusList, fieldListMap } })
}

const defaultProgramBookingInfoField = {
    programBooking: ['id', 'memberName', 'programTitle', 'programRefundNotiHtml', 'targetDateTime', 'programBookingSelectOptionList', 'programBookingSubjectOptionList', 'paidAmount', 'paidDateTime', 'requestCancelDateTime', 'status', 'tossPayId', 'orderId', 'totalAmount', 'availableRefundAmount', 'tossPayCancelList', 'programBookingStatusHistoryList', 'programBookingMemoList',],
    programBookingSelectOptionList: ['id', 'programSelectOptionId', 'programSelectOptionItemIdList', 'programSelectOptionName', 'programSelectOptionItemList'],
    programSelectOptionItemList: ['id', 'name'],
    programBookingSubjectOptionList: ['id', 'programSubjectOptionId', 'content', 'programSubjectOptionName'],
    programBookingStatusHistoryList: ['id', 'createdDate', 'memberName', 'content'],
    programBookingMemoList: ['id', 'memo', 'createdDate', 'memberName'],
    tossPayCancelList: ['id', 'cancelAmount', 'cancelReason', 'canceledAt'],
}

export const getProgramBookingInfoByProgramBookingId = <T>(programBookingId: number, programBookingField = defaultProgramBookingInfoField) => {
    const { queryFieldListMap, fieldListMap } = transformData(programBookingField)
    const query = `query getProgramBookingInfoByProgramBookingId($programBookingId:ID, $fieldListMap: JSON) { getProgramBookingInfoByProgramBookingId(programBookingId:$programBookingId, fieldListMap:$fieldListMap) { ${queryFieldListMap} } }`
    return api.post<IGraphqlResponse<{ getProgramBookingInfoByProgramBookingId: T }>>(`/graphql`, { query, variables: { programBookingId, fieldListMap } })
}


export const createProgramBookingMemoByCreateProgramBookingMemoAdminRequest = (createProgramBookingMemoAdminRequest: ICreateProgramBookingMemoAdminRequest) => {
    return api.post<boolean>(`/program/booking/memo/admin`, createProgramBookingMemoAdminRequest)
}

export const programBookingTicketCountByProgramEventIdAndStatusIn = (programIdEventId: number, statusList: string[]) => {
    return api.get<number>(`/program-booking-ticket/count/status/admin/${programIdEventId}?statusList=${statusList.join(',')}`)
}